import Plugin from 'src/plugin-system/plugin.class';
import browserUpdate from 'browser-update';

export default class BrowserUpdatePlugin extends Plugin {

    init() {
        browserUpdate(
            {
                required: {
                    e:12,
                    i:11,
                    f:-5,
                    o:-5,
                    s:-4,
                    c:-4,
                },
                insecure: true,
                api: 2021.09
            }
        );
    }

}